import type { CityConfig } from "@/pages/city-template/types";

export const hudsonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hudson",
  state: "New York",
  stateAbbr: "NY",
  slug: "hudson-ny",
  route: "/hudson-ny",
  title: "Emergency Passport Hudson, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hudson, NY — as fast as 24 hours. Registered State Dept. courier serving Warren Street antiques dealers, NYC weekenders, Amtrak Empire Corridor travelers, ALB/SWF/JFK airport access, and all Columbia County communities with the best price guarantee.",
  h1: "Emergency & Expedited Passport Services in Hudson, NY",
  heroSubtitle: "Warren Street antiques dealer heading to a Paris auction next week? NYC weekender's spontaneous trip to London leaving from Hudson Amtrak? Columbia County artist at a Berlin gallery opening in 10 days? We help Hudson residents — from Warren Street gallerists to Kinderhook families to Chatham farmers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20historic%20Hudson%20New%20York%20waterfront%20along%20the%20Hudson%20River%20with%20charming%20Warren%20Street%20lined%20with%20antique%20shops%20art%20galleries%20and%20boutique%20stores%2C%20Columbia%20County%20countryside%20with%20rolling%20farmland%20green%20hills%20and%20distant%20Catskill%20Mountains%20in%20soft%20focus%2C%20warm%20golden%20autumn%20afternoon%20light%20casting%20long%20shadows%20across%20the%20riverfront%2C%20historic%20brick%20and%20Victorian%20architecture%2C%20modern%20editorial%20travel%20photography%20with%20rich%20warm%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition%20showing%20an%20arts%20and%20antiques%20destination%20town&width=1600&height=700&seq=hudson-ny-hero-v2-001&orientation=landscape",
  heroImageAlt: "Historic Hudson New York waterfront along the Hudson River with Warren Street and Columbia County countryside at golden hour",
  geoPosition: "42.2528;-73.7900",
  geoPlacename: "Hudson, New York, United States",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~110 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Hudson", zips: "12534" },
    { name: "Kinderhook", zips: "12106" },
    { name: "Chatham", zips: "12037" },
    { name: "Ghent", zips: "12075" },
    { name: "Philmont", zips: "12565" },
    { name: "Claverack", zips: "12513" },
    { name: "Athens", zips: "12015" },
    { name: "Stottville", zips: "12172" },
    { name: "Germantown", zips: "12526" },
    { name: "Stuyvesant", zips: "12173" },
    { name: "Catskill", zips: "12414" },
    { name: "Red Hook", zips: "12571" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12250, 12252, 12255-12257, 12260-12262, 12288" },
    { name: "Kingston", zips: "12401, 12402, 12411, 12429, 12432, 12441, 12449, 12484, 12485, 12487, 12490, 12491, 12492, 12496" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Hudson-area travelers with immediate departures, including last-minute art world events." },
    { icon: "ri-flight-takeoff-line", title: "Tri-Airport Hudson Valley Access", desc: "ALB (40 miles), SWF (55 miles), JFK (110 miles). We know every airline route and timeline for Columbia County travelers." },
    { icon: "ri-train-line", title: "Amtrak Empire Corridor Convenience", desc: "Hudson's Amtrak station provides direct rail to NYC Penn Station in 2 hours. Many Hudson residents use Amtrak to connect to JFK or Newark for international flights — we coordinate passport timing with your train departure." },
    { icon: "ri-store-2-line", title: "Warren Street Arts & Antiques Economy", desc: "Hudson is one of America's premier antiques destinations. Dealers and gallerists travel internationally for auctions, art fairs, and estate sales — often on very short notice." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albany, NY", route: "/albany-ny" },
    { name: "Expedited passport in Kingston, NY", route: "/kingston" },
    { name: "Quick passport services in Catskill, NY", route: "/catskill" },
    { name: "Urgent passport services in Poughkeepsie, NY", route: "/poughkeepsie" },
    { name: "New York passport services overview", route: "/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Hudson and all of Columbia County via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Hudson residents can ship from any UPS Store, FedEx Office, or post office location across Columbia County.",
  fpcOfficeDistance: "Serving Hudson, Kinderhook, Chatham, Ghent, Philmont, Claverack, Germantown, and all Columbia County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Hudson and the greater Columbia County. From the Warren Street antiques district to the historic estates of Kinderhook, from the rolling farmland of Chatham and Ghent to the riverfront communities of Germantown and Stuyvesant — we serve all of Columbia County. Our courier service eliminates the need to drive 110 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Hudson and all Columbia County communities including Kinderhook, Chatham, Ghent, Philmont, Claverack, Germantown, Stuyvesant, and Athens. We also serve travelers departing from ALB, SWF, and JFK airports who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Hudson as simple as possible — with the speed Warren Street art dealers, NYC weekenders, and Columbia County travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Hudson travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Hudson travelers encounter unique passport issues — everything from last-minute auction travel to Amtrak-to-JFK international connections to art fair deadlines. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Hudson travelers — from Warren Street antiques dealers to Columbia County artists to Kinderhook families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Hudson, NY? Here are the most common ones we hear from Columbia County area travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before an auction trip to London, an emergency passport for a last-minute gallery opening in Berlin, or a first-time passport for a Columbia County family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Paris auction house just notified you about a lot closing next week? Berlin gallery opening requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Columbia County area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Hudson residents renew fast — no agency visit required for most renewals. Perfect for Warren Street antiques dealers, Columbia County artists, and Hudson Valley professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Hudson residents through every step — from Warren Street to Kinderhook to Chatham — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Hudson art fair trip or Amtrak-to-JFK connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Columbia County family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Hudson residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Warren Street antiques dealers and gallerists who travel to Europe for auctions while their primary passport is in visa processing for another country.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Columbia County travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Hudson residents making weekend trips to Montreal via the Northway.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: "Canada Ready",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hudson NY", description: "Urgent passport processing for Hudson New York travelers with immediate departure needs from ALB, SWF, or JFK." },
    { name: "Expedited Passport Renewal Hudson NY", description: "Fast passport renewal for Hudson New York residents with a previously-issued passport." },
    { name: "First-Time Passport Hudson NY", description: "New passport application services for Hudson New York residents applying for their first passport." },
    { name: "Child Passport Hudson NY", description: "Minor passport services for Hudson New York families with children under 16." },
    { name: "Name Change Passport Hudson NY", description: "Passport name correction after marriage, divorce, or legal name changes for Hudson residents." },
    { name: "Second Passport Hudson NY", description: "Second passport services for Hudson antiques dealers, gallerists, and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Kevin A.",
      location: "Warren Street, Hudson",
      rating: 5,
      text: "I am an antiques dealer on Warren Street and got wind of an estate auction in the UK closing in 6 days. My passport expired 3 months ago and I had no idea. Fast Passport Center got it renewed in 48 hours. I made the auction, won the lot, and the commission more than covered the service. Essential for Hudson's antiques trade.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Chen Family",
      location: "Kinderhook, NY",
      rating: 5,
      text: "We live in NYC during the week and Kinderhook on weekends. Our kids' passports expired and we had a trip to visit family in China booked. They walked us through everything and all four passports arrived in 5 days. Amazing service for Columbia County weekenders.",
      service: "Child Passport Renewal — Family",
    },
    {
      name: "Maria G.",
      location: "Chatham, NY",
      rating: 5,
      text: "I am an artist with a gallery show in Berlin and needed a name change on my passport after getting married. They handled everything remotely — I shipped from the UPS Store in Hudson and had my corrected passport back in 4 days. The gallerist was impressed I got it sorted so fast.",
      service: "Name Change Passport",
    },
    {
      name: "David L.",
      location: "Ghent, NY",
      rating: 5,
      text: "Second time using Fast Passport Center. I take the Hudson Amtrak to Penn Station then connect to JFK for international flights. They understand the Amtrak-JFK timeline and always coordinate perfectly. My passport renewal was back in 4 days. Won't use anyone else.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hudson-1",
      name: "Hudson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "365 Fairview Avenue",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "518-828-1575",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Hudson — near Warren Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hudson passport acceptance facility. Passport photos available on-site. Appointment recommended — busiest during summer tourism and antiques fair weekends.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-2",
      name: "Chatham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31 Main Street",
      city: "Chatham",
      state: "NY",
      zip: "12037",
      phone: "518-392-2221",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Chatham — ~12 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Chatham, Ghent, and east Columbia County. Less crowded than Hudson Main — good option during peak tourism season.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-3",
      name: "Kinderhook Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3 Hudson Street",
      city: "Kinderhook",
      state: "NY",
      zip: "12106",
      phone: "518-758-6114",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Kinderhook — ~8 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Kinderhook, Stuyvesant, and south Columbia County. Convenient for weekend residents from NYC arriving Friday evening.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-4",
      name: "Columbia County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "560 Warren Street",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "518-828-3339",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Downtown Hudson — Warren Street",
      website: "https://www.columbiacountyny.com/countyclerk.html",
      websiteLabel: "Columbia County Clerk",
      notes: "County clerk passport acceptance right on Warren Street — most convenient for antiques dealers and downtown residents. Excellent for first-time applicants. No passport photos on-site.",
      icon: "ri-government-line",
    },
    {
      id: "hudson-5",
      name: "Catskill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Main Street",
      city: "Catskill",
      state: "NY",
      zip: "12414",
      phone: "518-943-4220",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Catskill — across the Hudson River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Greene County — convenient backup when Hudson facilities are booked. Just across the Rip Van Winkle Bridge from Hudson.",
      icon: "ri-mail-line",
    },
    {
      id: "hudson-6",
      name: "Hudson Amtrak Station",
      type: "Transit Hub — New York City Connector",
      address: "69 S Front Street",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "800-872-7245",
      hours: "Station open daily 6:00 AM – 9:30 PM",
      distance: "Downtown Hudson — Hudson River waterfront",
      website: "https://www.amtrak.com/stations/hud",
      websiteLabel: "Amtrak Hudson Station",
      notes: "Hudson's Amtrak station on the Empire Corridor provides direct rail service to New York Penn Station in 2 hours. Many Hudson residents use Amtrak to connect to JFK or Newark for international flights. Passport must be valid before boarding.",
      icon: "ri-train-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 110 miles to Manhattan Passport Agency", fpc: "Most Hudson travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Auction & Art Fair Urgency", agency: "No accommodation for short-notice art world travel", fpc: "We understand auction house and art fair deadlines — these trips often have 3–7 day booking windows" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Columbia County-Specific Guidance", agency: "Generic — no Amtrak, ALB/SWF/JFK, or Warren Street expertise", fpc: "Full Columbia County/Amtrak/Warren Street/ALB-SWF-JFK knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Amtrak-to-JFK International Connection Passport Gap",
      description: "Many Hudson residents take Amtrak to Penn Station, then connect to JFK for international flights. They discover at Penn Station — 2 hours from home — that their passport is expired. Your passport must be valid before you board the train, not just before the international leg.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Last-Minute Auction & Art Fair Travel",
      description: "Warren Street antiques dealers and gallerists often get 3–7 days notice for European auctions, estate sales, and art fairs. Standard passport processing is impossible — even expedited services struggle. Our 24-hour emergency channel handles these compressed timelines.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards at Local Pharmacies",
      description: "Many Hudson-area CVS and Walgreens locations produce photos that fail State Department standards — especially shadowing and background issues. For art world professionals whose passport photo might be scrutinized at international galleries, photo quality matters doubly. We catch failures in review.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Columbia County weekend families — especially those splitting time between NYC and upstate — frequently overlook the DS-3053 consent form when one parent is in the city while the other is upstate with the kids. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Multiple Schengen Area Entries",
      description: "Hudson art dealers and gallerists often plan multi-country European trips — London auction, then Paris fair, then Basel exhibition. Multiple Schengen entries require passport validity well beyond the return date. We flag the total itinerary requirements before submission.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, gallery, or Warren Street shop." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — including multi-country itinerary review for art world travelers hitting multiple European stops." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Hudson clients ship from the UPS Store on Warren Street or FedEx in Catskill — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 110 miles or take Amtrak to Manhattan just for the Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Hudson?", a: "We offer Hudson-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We understand the compressed timelines of auction houses, art fairs, and gallery openings that Hudson's creative economy depends on." },
    { q: "Do I need to visit a Hudson office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Hudson Post Office on Fairview Avenue or the Columbia County Clerk on Warren Street), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Hudson address." },
    { q: "Where can I get a passport acceptance in Hudson?", a: "Hudson has acceptance at the Main Post Office on Fairview Avenue and the Columbia County Clerk at 560 Warren Street — right in the antiques district. Nearby facilities in Chatham, Kinderhook, and Catskill provide additional options. We maintain an updated list with hours and appointment availability." },
    { q: "Can I take Amtrak from Hudson to JFK for my international flight?", a: "Yes — Hudson's Amtrak station provides direct service to NYC Penn Station (2 hours), where you can connect to JFK or Newark. However, you must have your valid passport BEFORE you board the train in Hudson. We coordinate passport processing around your Amtrak departure so your documents are in hand before you leave Columbia County." },
    { q: "What is the best price for expedited passport service in Hudson?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Hudson applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Columbia County-specific checklist." },
    { q: "Can I get a passport photo in Hudson?", a: "Yes — the Hudson Post Office on Fairview Avenue has on-site photo services. CVS, Walgreens, and UPS Store locations in Hudson and Catskill also offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "I am a Warren Street antiques dealer — do you understand auction travel urgency?", a: "Yes — we regularly handle passport emergencies for Hudson's antiques and art community. Auction house notifications often give just 3–7 days before a lot closes. We have expedited passports for Hudson dealers heading to London, Paris, Brussels, and Hong Kong on these compressed timelines." },
    { q: "How do I check my Hudson passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Hudson to final return shipping typically matches your chosen speed tier." },
    { q: "Is Hudson near a passport agency?", a: "The New York Passport Agency is at 376 Hudson Street in Manhattan — approximately 110 miles south. However, it only serves life-or-death emergencies. For standard expedited needs — even urgent auction or art fair travel — our courier channel is faster and more accessible than agency appointments." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Hudson Residents",
    intro: "Hudson's identity as an arts and antiques destination with excellent Amtrak access and a growing NYC-weekender population creates passport timing challenges that mix creative-world urgency with transit logistics. Here's what Hudson travelers need to know.",
    cards: [
      {
        icon: "ri-train-line",
        title: "Amtrak Empire Corridor — Hudson's Rail Connection to the World",
        subtitle: "Hudson Amtrak Station — 2 hours to New York Penn Station",
        description: "Hudson's beautifully restored Amtrak station on the Empire Corridor is the city's primary link to international travel. Residents take the train to Penn Station, then connect to JFK AirTrain or Newark Airport Express. This Amtrak-JFK pipeline is so common that many Hudson residents book international flights without thinking about their passport until the day before the train departs. The Amtrak convenience creates a false sense of time — a passport issue discovered at Penn Station, 2 hours from home, with a flight in 4 hours, is a travel catastrophe.",
        tip: "Your passport must be valid before you board Amtrak in Hudson, not just before the international leg. If your connecting flight is international, the airline may verify your passport at Penn Station or the airport check-in.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "40 miles north — Capital Region's airport",
        description: "Albany International is Hudson's closest airport. Many Hudson residents — especially those in northern Columbia County — prefer ALB's short drive and easy parking over the Amtrak-to-JFK journey. ALB offers domestic connections to major hubs including JFK, Newark, Chicago, and Atlanta. For Hudson travelers who want the simplest possible international departure, ALB's domestic connection to an international gateway is often the most practical option.",
        tip: "ALB is domestic-only for most routes. Your passport must be valid at ALB check-in if any segment of your itinerary is international — including connections.",
      },
      {
        icon: "ri-store-2-line",
        title: "Warren Street Art & Antiques Economy — Global Auction Travel",
        subtitle: "One of America's premier antiques destinations — 50+ dealers on a single mile-long street",
        description: "Hudson's Warren Street is legendary in the antiques and decorative arts world. Dealers and gallerists travel internationally year-round: London auctions (Sotheby's, Christie's), Paris flea markets and Biennale, Brussels art fairs, Hong Kong antiques week, and European estate sales. These trips often materialize with just days of notice — an auction house calls about a lot, a collector tips off a dealer about an estate, an art fair accepts a last-minute exhibitor. The 3–7 day booking-to-departure window is standard in this industry, and passport urgencies are a recurring reality.",
        tip: "Antiques dealers heading to Europe for auctions should maintain at least 6 months of passport validity at all times. Auction dates are fixed and unmovable — a passport renewal in standard processing will never arrive in time for a last-minute auction trip.",
      },
      {
        icon: "ri-palette-line",
        title: "Hudson's Creative Economy — Artists, Gallerists & NYC Weekenders",
        subtitle: "Columbia County's thriving arts scene and second-home community",
        description: "Hudson has become a magnet for artists, gallerists, and creative professionals who split time between NYC and upstate. Basilica Hudson and the numerous galleries along Warren Street draw international artists and audiences. NYC weekenders — families with second homes in Kinderhook, Ghent, and Chatham — often book international travel from their Columbia County base, not their city apartment. This means they discover passport issues on a Friday evening in Hudson with a flight departing Sunday from JFK — creating a compressed weekend timeline for urgent processing.",
        tip: "NYC weekenders should keep passports at their Columbia County home, not their city apartment. Discovering an expired passport Friday evening in Hudson with a Sunday JFK departure gives almost no time to fix the problem.",
      },
    ],
    callout: {
      icon: "ri-auction-line",
      title: "The Auction House Dilemma — Hudson's Most Unique Passport Urgency",
      description: "No other small city in America generates as much last-minute international travel from auction house notifications as Hudson. When Sotheby's or Christie's calls about a lot closing in 5 days, Hudson dealers need their passport NOW — not in 8 weeks. Our 24-hour and 2–9 day channels exist precisely for this uniquely Hudson travel pattern.",
    },
  },
  destinations: {
    title: "Where Hudson Travelers Go — And Why Passports Get Urgent",
    intro: "Hudson's arts-and-antiques economy and creative community create a distinctive international travel profile. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "33%", label: "of Hudson expedited requests are antiques/art/auction-related with 3–7 day notice" },
      { stat: "1–2 Weeks", label: "average lead time Hudson dealers have from auction notification to international departure" },
      { stat: "Apr–Jun & Sep–Nov", label: "peak seasons when spring and fall auction calendars, art fairs, and European buying trips converge" },
      { stat: "36 Hours", label: "shortest turnaround for a Warren Street dealer heading to a London auction" },
    ],
    destinations: [
      { name: "United Kingdom", context: "London auctions (Sotheby's, Christie's, Bonhams), English antiques buying trips, gallery exhibitions", urgency: "Auction house notifications give 3–7 days — the most compressed timeline in the project", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Paris flea markets, Biennale des Antiquaires, Maison & Objet, gallery shows, wine country tours", urgency: "Paris auction and fair dates are fixed annually — dealers plan around them", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Milan design fair, Venice Biennale, Tuscan antiques, Columbia County artists at European residencies", urgency: "Artist residency acceptance letters arrive 4–6 weeks before start date", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Berlin gallery scene, Cologne art fair, Munich antiques, Hudson artists at Berlin residencies", urgency: "Gallery opening dates are fixed — artists need passports ready for installation week", icon: "ri-map-pin-2-line" },
      { name: "Belgium & Netherlands", context: "Brussels antiques fair (BRAFA), Amsterdam gallery district, design auctions", urgency: "BRAFA and design fair dates create predictable quarterly urgency spikes", icon: "ri-map-pin-2-line" },
      { name: "Hong Kong & Asia", context: "Hong Kong antiques week, Asian art market, Hudson dealers sourcing inventory", urgency: "Long-haul flights with multi-country itineraries require careful passport validity review", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Catskill", route: "/catskill" },
      { name: "Kingston", route: "/kingston" },
      { name: "Rhinebeck", route: "/rhinebeck" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Hudson", address: "351 Fairview Avenue, Hudson, NY 12534", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Catskill", address: "280 W Bridge Street, Catskill, NY 12414", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Hudson", address: "160 Fairview Avenue, Hudson, NY 12534", hours: "Mon–Fri 8:30 AM – 7:00 PM, Sat 9:00 AM – 5:00 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Hudson Post Office Photo", address: "365 Fairview Avenue, Hudson, NY 12534", hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walmart Photo Center — Catskill", address: "30 Catskill Commons, Catskill, NY 12414", hours: "Daily 7:00 AM – 10:00 PM", website: "https://www.walmart.com/photo" },
    { name: "Rite Aid — Chatham", address: "35 Coleman Street, Chatham, NY 12037", hours: "Daily 8 AM – 9 PM", website: "https://www.riteaid.com/" },
    { name: "Walgreens — Valatie", address: "2961 Route 9, Valatie, NY 12184", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Albany", address: "1475 Western Avenue, Albany, NY 12203", hours: "Mon–Fri 8:00 AM – 9:00 PM, Sat–Sun 10:00 AM – 6:00 PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hudson",
      address: "560 Warren Street, Hudson, NY 12534",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Hudson DMV office right on Warren Street for license renewals and REAL ID applications. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Catskill",
      address: "411 West Bridge Street, Catskill, NY 12414",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Catskill DMV office serving Greene County. Convenient backup when Hudson appointments are full.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~40 miles from Hudson",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with domestic connections to all major hubs. Most convenient for Hudson-area travelers who prefer driving over the train.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "~55 miles from Hudson",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley airport with flights to major hubs including Dublin. Alternative for Hudson travelers.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "SWF Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options for Columbia County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Columbia County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Columbia County Clerk at 560 Warren Street in Hudson. Certified copies available for name changes and legal purposes.",
      url: "https://www.columbiacountyny.com/countyclerk.html",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Columbia County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/3jd/columbia/",
    },
  ],
};

export default hudsonConfig;